import "./../css/sass/styles.scss";

import './components/slider';
import './components/forms';
import './components/ticker-number';
import './components/support-feed';
import './components/process-steps-carousel';

jQuery(document).ready(function ($) {
  jQuery(".scroll-spy").scrollSpy({
    offsetElement: ".header",
    ignoreAnchors: [".not"],
  });

  jQuery(".scroll-spy").scrollSpy({
    offset: 0,
    scrollDuration: 0,
    scrollEasing: "swing",
  });

  jQuery(".scroll-spy").scrollSpy({
    activeClass: "current",
  });

  jQuery(".scroll-spy").scrollSpy({
    anchors: ["a[href*=\\#]"],
  });
});

jQuery(document).ready(function ($) {
  var maxHt = Math.max.apply(
    null,
    $(".landing_publications .uabb-infobox-title")
      .map(function () {
        return $(this).height();
      })
      .get()
  );
  $(
    "<style type='text/css'> .landing_publications .uabb-infobox-title { min-height:" +
      (maxHt + 0) +
      "px;} </style>"
  ).appendTo("head");
});

jQuery(document).ready(function ($) {
  var maxHt = Math.max.apply(
    null,
    $(".feature-info .uabb-infobox-title")
      .map(function () {
        return $(this).height();
      })
      .get()
  );
  $(
    "<style type='text/css'> .feature-info .uabb-infobox-title { min-height:" +
      (maxHt + 0) +
      "px;} </style>"
  ).appendTo("head");
});

jQuery(document).ready(function ($) {
  jQuery(".ubermenu-responsive-toggle").on("ubermenutoggledopen", function (e) {
    jQuery("header").addClass("menuopen");
  });
  jQuery(".ubermenu-responsive-toggle").on("ubermenutoggledclose", function (e) {
    jQuery("header").removeClass("menuopen");
  });
});

jQuery(document).ready(function ($) {
  var maxHt = Math.max.apply(
    null,
    $(".news_post h4.uabb-infobox-title")
      .map(function () {
        return $(this).height();
      })
      .get()
  );
  $(
    "<style type='text/css'> .news_post h4.uabb-infobox-title { min-height:" +
      (maxHt + 0) +
      "px;} </style>"
  ).appendTo("head");
});

jQuery(document).ready(function ($) {
  // var maxHt = Math.max.apply(null, $(".eq_height_infobox .uabb-infobox-title").map(function() { return $(this).height(); }).get());
  // $("<style type='text/css'> .eq_height_infobox .uabb-infobox-title { min-height:" + (maxHt + 0) + "px;} </style>").appendTo("head");

  var maxHt = Math.max.apply(
    null,
    $(".mob_home_publications h5.uabb-infobox-title")
      .map(function () {
        return $(this).height();
      })
      .get()
  );
  $(
    "<style type='text/css'> .mob_home_publications h5.uabb-infobox-title { min-height:" +
      (maxHt + 0) +
      "px;} </style>"
  ).appendTo("head");

  var maxHt = Math.max.apply(
    null,
    $(".Scientific_Founders h5.uabb-infobox-title")
      .map(function () {
        return $(this).height();
      })
      .get()
  );
  $(
    "<style type='text/css'> .Scientific_Founders h5.uabb-infobox-title { min-height:" +
      (maxHt + 0) +
      "px;} </style>"
  ).appendTo("head");

  if ($(window).width() < 767) {
    var maxHt = Math.max.apply(
      null,
      $(".BOD_column .uabb-infobox-text")
        .map(function () {
          return $(this).height();
        })
        .get()
    );
    $(
      "<style type='text/css'> .BOD_column .uabb-infobox-text { min-height:" +
        (maxHt + 0) +
        "px;} </style>"
    ).appendTo("head");
  }
});

/**
 * BEGIN -- Set all equal_elements within the collection to have the same height.
 **/
jQuery(document).ready(function ($) {
  $.fn.equalHeight = function () {
    var heights = [];
    $.each(this, function (i, equal_element) {
      $equal_element = $(equal_element);
      var equal_element_height;
      // Should we include the equal_elements padding in it's height?
      var includePadding =
        $equal_element.css("box-sizing") == "border-box" ||
        $equal_element.css("-moz-box-sizing") == "border-box";
      if (includePadding) {
        equal_element_height = $equal_element.innerHeight();
      } else {
        equal_element_height = $equal_element.height();
      }
      heights.push(equal_element_height);
    });
    this.height(Math.max.apply(window, heights));
    return this;
  };

  /**
   * Create a grid of equal height equal_elements.
   */
  $.fn.equalHeightGrid = function (columns) {
    var $tiles = this;
    $tiles.css("height", "auto");
    for (var i = 0; i < $tiles.length; i++) {
      if (i % columns == 0) {
        var row = $($tiles[i]);
        for (var n = 1; n < columns; n++) {
          row = row.add($tiles[i + n]);
        }
        row.equalHeight();
      }
    }
    return this;
  };

  /**
   * Detect how many columns there are in a given layout.
   */
  $.fn.detectGridColumns = function () {
    var offset = 0,
      cols = 0;
    this.each(function (i, elem) {
      var elem_offset = $(elem).offset().top;
      if (offset == 0 || elem_offset == offset) {
        cols++;
        offset = elem_offset;
      } else {
        return false;
      }
    });
    return cols;
  };

  /**
   * Ensure equal heights now, on ready, load and resize.
   */
  $.fn.responsiveEqualHeightGrid = function () {
    var _this = this;
    function syncHeights() {
      var cols = _this.detectGridColumns();
      _this.equalHeightGrid(cols);
    }
    $(window).bind("resize load", syncHeights);
    syncHeights();
    return this;
  };

  // On page load
  jQuery(".equal_element").responsiveEqualHeightGrid();
  jQuery(".eq_height_infobox .uabb-infobox-title").responsiveEqualHeightGrid();
  jQuery(".eq_height_infobox .uabb-infobox-text-wrap").responsiveEqualHeightGrid();
  jQuery(".events_info h3.uabb-infobox-title").responsiveEqualHeightGrid();
  jQuery(".events_info .uabb-infobox-text").responsiveEqualHeightGrid();
  jQuery(".protocols .resource_box h5.uabb-infobox-title").responsiveEqualHeightGrid();
  jQuery(".resource_box .uabb-infobox-text").responsiveEqualHeightGrid();
  //jQuery('.events_info h3.uabb-infobox-title').responsiveEqualHeightGrid();
  jQuery(".tech-product.our_products_col h4.uabb-infobox-title").responsiveEqualHeightGrid();
  jQuery(".tech-product.our_products_col .uabb-infobox-text p").responsiveEqualHeightGrid();
  jQuery(".home_prd_section .uabb-infobox-text p").responsiveEqualHeightGrid();
  jQuery(".home_prd_section h5.uabb-infobox-title").responsiveEqualHeightGrid();

  if ($(window).width() < 767) {
    jQuery(
      ".team_scientific_sec .Scientific_Founders h5.uabb-infobox-title"
    ).responsiveEqualHeightGrid();

    // jQuery('.BOD_column .uabb-infobox-text').responsiveEqualHeightGrid();
  }

  // On Ajax load more success
  window.almDone = function () {
    jQuery(".equal_element").responsiveEqualHeightGrid();
    jQuery(".eq_height_infobox .uabb-infobox-title").responsiveEqualHeightGrid();
    jQuery(".protocols .resource_box h5.uabb-infobox-title").responsiveEqualHeightGrid();
    jQuery(".resource_box .uabb-infobox-text").responsiveEqualHeightGrid();
    jQuery(".events_info h3.uabb-infobox-title").responsiveEqualHeightGrid();
    jQuery(".tech-product.our_products_col .uabb-infobox").responsiveEqualHeightGrid();
  };

  window.almComplete = function () {
    jQuery(".equal_element").responsiveEqualHeightGrid();
    jQuery(".eq_height_infobox .uabb-infobox-title").responsiveEqualHeightGrid();
    jQuery(".events_info h3.uabb-infobox-title").responsiveEqualHeightGrid();
    jQuery(".events_info .uabb-infobox-text").responsiveEqualHeightGrid();
    jQuery(".protocols .resource_box h5.uabb-infobox-title").responsiveEqualHeightGrid();
    jQuery(".resource_box .uabb-infobox-text").responsiveEqualHeightGrid();
    //jQuery('.events_info h3.uabb-infobox-title').responsiveEqualHeightGrid();
  };
});
/**
 * END -- Set all equal_elements within the collection to have the same height.
 **/


jQuery(document).ready(function () {
  jQuery(document).on("click", ".clickable_div", function () {
    var url = jQuery(this).find("a").attr("href");
    window.open(url, "_blank");
    return false;
  });
});


jQuery(document).ready(function () {
  if (navigator.platform.indexOf("Mac") > -1) {
    jQuery("body").addClass("macintosh");
  } else {
    jQuery("body").addClass("window");
  }
});


/*Suport Page Whole Vox Clickable*/
jQuery(document).ready(function ($) {
  if ("undefined" == typeof FLBuilder) {
    // Find all anchor tags
    $(".whole-box-clickable .resource_pdf").each(function () {
      var target = $(this).find("a").attr("target"); // Get target attribute value
        
      // Check if target is set to "_self"
      if (target === "_self") {
        // Bind click event to open link in same window
        $(this).click(function (e) {
          e.preventDefault(); // Prevent default link behavior
          window.location.href = $(this).find("a").attr("href"); // Navigate to link's URL
        });
      }
    });
  }
});

/* QuantumScale Page */
document.addEventListener('DOMContentLoaded', (e) => {

  // the Table element
  const tableTabs = document.querySelectorAll('#quantum-table-tabs .uabb-tab-link');
  const tableData = document.querySelectorAll('.grid-td');

  if (tableTabs.length > 0) {
    tableTabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        let colClass = '.sm-td';
        switch (index) {
          case 1: colClass = '.md-td';
          break;
          case 2: colClass = '.lg-td';
          break;
          case 3: colClass = '.xl-td';
          break;
          case 4: colClass = '.mod-td';
        }
        
        showColumn(colClass);
      });
    });
  }

  function showColumn(col) {
    tableData.forEach((cell) => {
      cell.classList.add('hide-column');
      cell.classList.remove('show-column');
    });
    const selectedColumn = document.querySelectorAll(col);
    selectedColumn.forEach((cell) => {
      cell.classList.add('show-column')
      cell.classList.remove('hide-column')
    });
  }

  // The slider element
  function showTwoSlides() {
    if (window.innerWidth > mobile) {
      const currentSlide = document.querySelector('.fl-slide[aria-hidden="false"]');
      const nextSlide = currentSlide.nextElementSibling;
      if (nextSlide) {
        nextSlide.ariaHidden = 'false';
      }
    }
  }

  function toggleButton(button) {
    if (button.classList.contains('quantum-disabled')) {
      button.classList.remove('quantum-disabled');
    } else {
      button.classList.add('quantum-disabled');
    }
  }

  function hideButtons() {
    const currentSlide = document.querySelector('.fl-slide[aria-hidden="false"]');
    const prevSlide = currentSlide.previousElementSibling !== null;
    const nextSlide = currentSlide.nextElementSibling !== null;

    if (!prevSlide) {
      toggleButton(document.querySelector('#quantum-slider .slider-prev'));
    } else if (!nextSlide) {
      toggleButton(document.querySelector('#quantum-slider .slider-next'));
    } else {
      const disabledButton = document.querySelector('.quantum-disabled');
      if (disabledButton) {
        disabledButton.classList.remove('quantum-disabled');
      }
    }
  }

  if (document.querySelector('body').classList.contains('page-id-6899')) {
    setTimeout(() => {
      showTwoSlides();
      hideButtons();
    }, 1000);

    window.addEventListener('resize', () => {
      clearTimeout(sliderThrottle);
      sliderThrottle = setTimeout(() => {
        showTwoSlides();
      }, 600);
    });
  }

  var mobile = 992,
      sliderThrottle;

  const sliderButtons = document.querySelectorAll('#quantum-slider .fl-content-slider-navigation a');

  if (sliderButtons.length > 0) {
    sliderButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          showTwoSlides();
          hideButtons();
        });
      });
    });
  }
});